import { render, staticRenderFns } from "./OrderPlaces.vue?vue&type=template&id=15fd9bba&scoped=true"
import script from "./OrderPlaces.vue?vue&type=script&lang=js"
export * from "./OrderPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd9bba",
  null
  
)

export default component.exports